<template>
  <el-drawer
    v-model="drawerOpen"
    class="role-permission-edit-history-drawer"
    direction="rtl"
    size="520px"
    append-to-body
    :show-close="false"
    :close-on-click-modal="true"
  >
    <template #header="{ titleId, titleClass }">
      <span
        :id="titleId"
        :class="[titleClass, 'role-permission-edit-history-drawer__title']"
      >
        編集履歴
      </span>
    </template>
    <div v-loading="loading" class="role-permission-edit-history-drawer__body">
      <EditHistoryLog
        :items="items"
        :has-more="hasMore"
        :loading-more="loadingMore"
        @load-more="emit('load-more')"
      />
    </div>
    <template #footer>
      <div class="role-permission-edit-history-drawer__footer">
        <el-button
          class="role-permission-edit-history-drawer__footer-btn"
          @click="closeDrawer"
        >
          キャンセル
        </el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue';
  import EditHistoryLog, {
    type EditHistoryItem
  } from '@/pages/master/role-permission/EditHistoryLog.vue';

  const props = withDefaults(
    defineProps<{
      modelValue: boolean;
      items: EditHistoryItem[];
      hasMore?: boolean;
      loading?: boolean;
      loadingMore?: boolean;
    }>(),
    {
      hasMore: false,
      loading: false,
      loadingMore: false
    }
  );

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'open'): void;
    (e: 'load-more'): void;
  }>();

  watch(
    () => props.modelValue,
    (open, wasOpen) => {
      if (open && !wasOpen) emit('open');
    }
  );

  const drawerOpen = computed({
    get: () => props.modelValue,
    set: (value: boolean) => emit('update:modelValue', value)
  });

  const closeDrawer = () => {
    drawerOpen.value = false;
  };
</script>

<style lang="scss">
  .role-permission-edit-history-drawer {
    .el-drawer__header {
      margin-bottom: 0;
    }

    .role-permission-edit-history-drawer__title {
      font-weight: 700;
      font-size: 18px;
      line-height: 1.3;
      color: var(--el-text-color-primary);
    }

    .el-drawer__body {
      padding: 12px 16px 16px;
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      /* デフォルトの overflow:auto だと中身が短くても領域いっぱいに伸び、無意味なスクロールが出やすい */
      overflow: hidden;
    }

    .role-permission-edit-history-drawer__body {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }

    .role-permission-edit-history-drawer__footer {
      width: 100%;
    }

    .role-permission-edit-history-drawer__footer-btn {
      width: 100%;
    }

    .el-drawer__footer {
      padding: 12px 16px 16px;
      border-top: 1px solid var(--el-border-color-lighter);
    }
  }
</style>
